import Model from '../models/model'

const model = new Model({
	name: 'EndoSetupParameter',
	allowImport: false,
	disableDelete: true,
	disableAdd: true,
	disableExport: false,
	idProperty: '_id',
	readOnly: true,
	pageSize: 5,
	disableExportCSV: false,
	showGridRefreshBtn: true,
	gridRefreshInterval: 160000, //Long polling ms
	defaultSort: 'MachineModel ASC',
	title: 'EndoSetupParameter',
	filter: [{ "operator": "$eq", "property": "IsDeleted", "value": false }],
	columns: [
		{ header: 'EquipmentModel', field: 'MachineModel', width: 150 },
		{ header: 'ScopeModel', field: 'ScopeModel', width: 120 },
		{ header: 'ParameterSet', field: 'ParmSet', width: 140 },
		{ header: 'ParameterSetValue', field: 'ParameterSetValue', width: 400, pdfExportWidth: 500 },
	]
});

export const EndoParameterModel = model;
export default model.createFormBase();